module.exports = __webpack_public_path__ + "img/onedrive.956727e4.svg";